import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {Hexagon} from './hexagon';

// searchString and value is used by nested Dropdown
// eslint-disable-next-line no-unused-vars
export const HexagonText = ({searchString, value, text, subText, imgUrl, active, intl}) => {
	return (
		<Hexagon
			searchString={searchString}
			value={value}
			text={text}
			subText={subText}
			imgUrl={imgUrl}
			active={active}
			intl={intl}
		>
			{subText ? (
				<TextContainer>
					<HeadingText title={text}>{text}</HeadingText>
					<SubText title={subText}>{subText}</SubText>
				</TextContainer>
			) : (
				<Text title={text}>{text}</Text>
			)}
		</Hexagon>
	);
};

HexagonText.propTypes = {
	text: PropTypes.string.isRequired,
	subText: PropTypes.string,
	imgUrl: PropTypes.string,
	searchString: PropTypes.string,
	value: PropTypes.any,
	active: PropTypes.bool,
	intl: PropTypes.any,
};

export const Container = Styled.div`
	background-color: transparent;
	display: flex;
	flex-direction: row;
	padding: 5px 0;
	align-items: center;
	/* max-width: 100%; */
	height: 36px;
`;

const TextContainer = Styled.div`
	display: flex;
	flex-direction: column;
	/* max-width: 100%; */
	flex-grow: 1;
  	overflow: hidden;
`;

const Text = Styled.div`
	white-space: nowrap;
  	overflow: hidden;
  	text-overflow: ellipsis;
	padding: 0;
	margin: 0;
	flex-grow: 1;
	font-size: 13px;
	color: ${props => props.theme.colors.textLightGray};
`;

const HeadingText = Styled(Text)`
	font-size: 13px;
	font-weight: 500;
`;
const SubText = Styled(Text)`
	font-size:11px;
`;
